import _ from "lodash/fp";
import jp from "jsonpath";
import {createAction} from "redux-actions";
import {query} from "../../utilities/query";
import {isFilled} from "../../utilities/isfilled";

export const createTemplate = Object.assign(data => dispatch => {
  data  = _.cloneDeep(data);
  jp.apply(data, "documents", _.takeWhile(isFilled("title", "content")));
  jp.apply(data, "signers", _.takeWhile(isFilled("name", "ssn", "email", "phone")));

  return dispatch(query(createTemplate)("/api/template", "POST", data));
}, {
  success: createAction("templates/CREATE_SUCCESS", template => ({[template.name]: template})),
  failure: createAction("templates/CREATE_FAILURE")
});